var MitIDOutputEvent = {
  StartedAuthentication: 'Started Authentication',
  CanceledAuthentication: 'Canceled Authentication',
  CompletedAuthentication: 'Completed Authentication',
  InitLoginRedirect: 'initLoginRedir',
};

var MitIDInputEvent = {
  StartAuthentication: 'Start Authentication',
  CancelAuthentication: 'Cancel Authentication',
};

var IS_ON = 'is-on';

function sendMessage( message ) {
  var iframeElement = document.getElementById( 'js-vb-netbank-iframe-mitid' );
  var iframeContentWindow = iframeElement.contentWindow;
  iframeContentWindow.postMessage( message, '*' );
}

function shouldShowBackdrop( shouldShow ) {
  var backdropElement = document.querySelector( '.Backdrop' );
  if ( shouldShow ) {
    backdropElement.classList.add( IS_ON );
  }
  else {
    backdropElement.classList.remove( IS_ON );
  }
}

function shouldShowLoader( shouldShow ) {
  var loaderElement = document.querySelector( '.Backdrop-loader' );
  var actionsElement = document.querySelector( '.Backdrop-actions' );
  if ( shouldShow ) {
    loaderElement.classList.add( IS_ON );
    actionsElement.classList.remove( IS_ON );
  }
  else {
    loaderElement.classList.remove( IS_ON );
    actionsElement.classList.add( IS_ON );
  }
}

function onPostMessage( event ) {
  var message = event.data;
  if ( message === MitIDOutputEvent.StartedAuthentication ) {
    shouldShowBackdrop( true );
    shouldShowLoader( false );
  }
  else if ( message === MitIDOutputEvent.CanceledAuthentication ) {
    shouldShowBackdrop( false );
    shouldShowLoader( false );
  }
  else if ( message === MitIDOutputEvent.CompletedAuthentication ) {
    shouldShowBackdrop( true );
    shouldShowLoader( true );
  }
}

window.addEventListener( 'message', onPostMessage );

window.startAuthentication = function () {
  //sendMessage( MitIDInputEvent.CancelAuthentication );
  sendMessage( MitIDInputEvent.StartAuthentication );
  shouldShowBackdrop( true );
};
window.cancelAuthentication = function () {
  sendMessage( MitIDInputEvent.CancelAuthentication );
  shouldShowBackdrop( false );
  shouldShowLoader( false );
};